<template>
  <div class="container">
    <a-back-top :target="targetFn">
      <div class="ant-back-top-inner">
        <a-icon type="caret-up" />
      </div>
    </a-back-top>
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('resourceDetails.back') }}</span>
    </div>
    <div class="file">
      <img class="cover" :src="data.cover" />
      <div class="right-content">
        <div>
          <a-tooltip>
            <template slot="title">
              {{ data.name }}
            </template>
            <div class="name ellipsis-single">{{ data.name }}</div>
          </a-tooltip>
          <span>{{ data.file.files.length > 0 ? data.file.files[0].type || data.file.files[0].format : ' ' }}</span>
        </div>
        <div>{{ $t('resourceDetails.version') }}：{{ data.versionStr || data.version }}</div>
        <div class="button">
          <!-- <span v-if="data.typeName === '3D实训软件' && data.isAuth" @click="openSoftware">
            {{ $t('resourceDetails.openSoftware') }}
            <img src="@/assets/icons/icon_dk.png" alt="" srcset="" />
          </span> -->
          <span v-if="!data.isAuth && resType === 2">
            {{ $t('resourceDetails.noAuth') }}
            <img src="@/assets/icons/icon_sq.png" alt="" srcset="" />
          </span>
        </div>
      </div>
      <div class="like">
        <div :class="data.isBookmark ? 'already' : ''" @click="feedback(data.isBookmark ? 'uncollect' : 'collect')">
          <img v-if="data.isBookmark" src="@/assets/icons/icon_sc_d@2x.png" alt="" />
          <img v-else src="@/assets/icons/icon_collect@2x.png" alt="" />
          <span>{{ $t('resourceDetails.collect.collect') }}({{ data.bookmarkNumber }})</span>
        </div>
        <div :class="data.isLike ? 'already' : ''" @click="feedback(data.isLike ? 'unlike' : 'like')">
          <img v-if="data.isLike" src="@/assets/icons/icon_z_d@2x.png" alt="" />
          <img v-else src="@/assets/icons/icon_z@2x.png" alt="" />
          <span>{{ $t('resourceDetails.collect.like') }}({{ data.likeNumber }})</span>
        </div>
      </div>
    </div>
    <a-tabs v-model="tabKey" @change="callback">
      <a-tab-pane :key="1" :tab="$t('resourceDetails.tabs.details')">
        <div class="info">
          <div class="title">
            <img src="@/assets/icons/icon_zy_info.png" alt="" srcset="" />
            <span class="label">{{ $t('resourceDetails.info.title') }}</span>
          </div>
          <div class="content">
            <div>
              <span v-if="data.typeName !== '3D实训软件'">
                <img src="@/assets/icons/icon_bb.png" alt="" srcset="" />
                <span class="label">{{ $t('resourceDetails.info.version') }}</span>
                <span>{{ data.versionStr || data.version }}</span>
              </span>
              <span>
                <img src="@/assets/icons/icon_res_zy.png" alt="" srcset="" />
                <span class="label">{{ $t('resourceDetails.info.type') }}</span>
                <span>{{ data.typeName }}</span>
              </span>
              <span v-if="data.typeName === '图片类' || data.typeName === '视频类'">
                <img v-if="data.typeName === '图片类'" src="@/assets/icons/icon_pic@2x.png" alt="" srcset="" />
                <img v-else src="@/assets/icons/icon_sp@2x.png" alt="" srcset="" />
                <span class="label">{{ getTypeName }}</span>
                <span>{{ data.subTypeName }}</span>
              </span>
              <span>
                <img src="@/assets/icons/icon_gs.png" alt="" srcset="" />
                <span class="label">{{ $t('resourceDetails.info.format') }}</span>
                <span>
                  {{ data.file.files.length > 0 ? data.file.files[0].type || data.file.files[0].format : '' }}
                </span>
              </span>
              <span>
                <img src="@/assets/icons/icon_dx.png" alt="" srcset="" />
                <span class="label">{{ $t('resourceDetails.info.size') }}</span>
                <span>{{ data.file.files.length > 0 ? formatFileSize(data.file.files[0].size) : '' }}</span>
              </span>
              <span v-if="data.typeName === '3D实训软件'">
                <img src="@/assets/icons/icon_sb.png" alt="" srcset="" />
                <span class="label">{{ $t('resourceDetails.info.device') }}</span>
                <a-tooltip v-if="deviceList.length > 0">
                  <template slot="title">
                    <div class="machine" v-if="deviceList.length > 0">
                      <span v-for="(name, index) in deviceList" :key="index">
                        {{ index === deviceList.length - 1 ? name : name + '、' }}
                      </span>
                    </div>
                  </template>
                  <div class="machine" v-if="deviceList.length > 0">
                    <span v-for="(name, index) in deviceList" :key="index">
                      {{ index === deviceList.length - 1 ? name : name + '、' }}
                    </span>
                  </div>
                </a-tooltip>
                <span v-else>
                  --
                </span>
              </span>
            </div>
            <div>
              <span class="label">{{ $t('resourceDetails.info.intro') }}</span>
              <span>{{ data.detail || '暂无' }}</span>
            </div>
          </div>
        </div>
        <div class="belong" v-if="getResType === 2">
          <div class="title">
            <img src="@/assets/icons/icon_sx.png" alt="" srcset="" />
            <span class="label">{{ $t('resourceDetails.property.title') }}</span>
          </div>
          <div class="content">
            <div>
              <span class="label profession">{{ $t('resourceDetails.property.profession') }}：</span>
              <!-- <b>：</b> -->
              <span v-for="(item, index) in data.profession" :key="item">
                {{ index === data.profession.length - 1 ? item : item + '、' }}</span
              >
            </div>
            <div v-if="data.typeName === '3D实训软件'">
              <span class="label profession">{{ $t('resourceDetails.property.industry') }}：</span>
              <span>{{ data.industryName }}</span>
            </div>
          </div>
        </div>
        <div class="belong" v-else>
          <div class="title">
            <img src="@/assets/icons/icon_sx.png" alt="" srcset="" />
            <span class="label">{{ $t('resourceDetails.belong.title') }}</span>
          </div>
          <div class="content">
            <div>
              <span class="label profession">{{ $t('resourceDetails.belong.creator') }}：</span>
              <!-- <b>：</b> -->
              <span>{{ data.username }}</span>
            </div>
            <div>
              <span class="label profession">版权方：</span>
              <!-- <b>：</b> -->
              <span>{{ data.copyrightOwner ? (data.copyrightOwner == 1 ? '学校' : '个人') : '暂无' }}</span>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane
        :key="2"
        :tab="$t('resourceDetails.tabs.preview')"
        v-if="!((getResType === 3 || getResType === 4) && data.typeName === '3D实训软件')"
      >
        <div v-if="data.typeName === '3D实训软件'">
          <!-- 资源展示轮播图 -->
          <Slideshow
            :resList="
              typeof data.softwareImage === 'string' && data.softwareImage.startsWith('[')
                ? JSON.parse(data.softwareImage)
                : [{ url: data.softwareImage, type: 'image' }]
            "
          ></Slideshow>
        </div>
        <Preview
          v-else
          ref="preview"
          class="preview-container"
          :isclass="false"
          :typeName="data.typeName"
          :subTypeName="data.subTypeName"
          :file="file"
        ></Preview>
      </a-tab-pane>
      <a-tab-pane :key="3" :tab="$t('resourceDetails.tabs.comments')">
        <commentComponents :allInterface="allInterface" :params="params"></commentComponents>
      </a-tab-pane>
    </a-tabs>
    <Modal :visible.sync="visible" />
    <PlayerModal ref="playerModal" :playerList="playerList" @selectPlayer="selectPlayer" />
  </div>
</template>
<script>
import cookie from 'js-cookie'
import Modal from '@/components/XRInfoModal/index'
import {
  resourceDetail,
  getPersonResDetails,
  resourceLike,
  resourceUnlike,
  resourceCollect,
  resourceUncollect,
  machineList
} from '@/api/lesson'
import { formatFileSize } from '@/utils/other'
import Preview from '@/components/preview/index'
import commentComponents from '@/components/comment/index'
import { BackTop } from 'ant-design-vue'
import Slideshow from './Slideshow.vue'
import PlayerModal from '@/components/PlayerModal/index.vue'

const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }

    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside)
    delete el.vueClickOutside
  }
}

export default {
  props: {
    resourceId: {
      type: Number,
      default: 0
    },
    resourceType: {
      type: Number,
      default: 0
    }
  },
  components: {
    Modal,
    Preview,
    commentComponents,
    'a-back-top': BackTop,
    Slideshow,
    PlayerModal
  },
  data() {
    return {
      allInterface: {
        list: '/resource/comment/list',
        delete: '/resource/comment/delete',
        reply: '/resource/comment',
        like: '/resource/comment/like',
        unlike: '/resource/comment/unlike'
      },
      params: {
        resId: '',
        resType: 1,
        res_url: ''
      },
      tabKey: 1,
      visible: false,
      data: {
        file: {
          id: undefined,
          cover: undefined,
          files: [{ format: '', version: '', machineName: '' }]
        },
        name: '',
        cover: '',
        format: '',
        isAuth: '',
        detail: '',
        version: '',
        typeName: '',
        playerId: '',
        profession: [],
        softwareImage: '',
        subTypeName: '',
        isLike: false,
        isBookmark: false,
        likeNumber: 0,
        bookmarkNumber: 0
      },
      playOption: [],
      playerName: undefined,
      formatFileSize: formatFileSize,
      playerList: [],
      playerKey: '',
      currentPlayer: {},
      deviceList: []
    }
  },
  computed: {
    getTypeName() {
      return this.data.typeName.slice(0, 2) + '类型：'
    },
    getId() {
      return this.resourceId ? this.resourceId : this.$route.query.id
    },
    getResType() {
      // type  1课程 2共享资源 3个人资源 4校级资源
      return this.resourceType ? this.resourceType : Number(this.$route.query.resType)
    }
  },
  directives: { clickoutside },
  methods: {
    targetFn() {
      return document.querySelector('.container')
    },
    // 收藏点赞
    optionClick(num) {
      if (num == 1) {
      } else {
      }
    },
    back() {
      if (this.resourceId) {
        this.$emit('back')
      } else {
        this.$router.go(-1)
      }
    },
    callback(key) {
      if (key === 2 || key === 3) {
        console.log('this.data.type ----->', this.data)
        if (!this.data.isAuth && this.data.typeName !== '3D实训软件') {
          this.tabKey = 1
          return this.$message.error(this.$t('resourceDetails.error.noAuth'))
        }
        if (this.data.file.files.length === 0) {
          this.tabKey = 1
          return this.$message.error(this.$t('resourceDetails.error.noPreview'))
        }
        this.file = this.data.file
      } else {
        if (!this.$refs.preview) return
        if (this.$refs.preview.$refs.video && !document.pictureInPictureEnabled) {
          this.$refs.preview.$refs.video.pause()
          this.$refs.preview.$refs.video.currentTime = 0
        }
        if (this.$refs.preview.$refs.audio) {
          this.$refs.preview.audio.play = false
          this.$refs.preview.$refs.audio.pause()
          this.$refs.preview.$refs.audio.currentTime = 0
        }
        // console.log(this.$refs.preview.$refs.video)
      }
    },
    openUriWithInputTimeoutHack(url, failCb, successCb) {
      const target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      const handler = this.registerEvent(target, 'blur', onBlur)

      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      location.href = url

      const timeout = setTimeout(function() {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    },
    registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function() {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function() {
            target.detachEvent(eventType, cb)
          }
        }
      }
    },
    Ok() {
      const userType = cookie.getJSON('user_type').join(',')
      const data = {
        data: Object.assign(cookie.getJSON('user_infor'), {
          resId: this.getId,
          token: localStorage.token,
          roles: cookie.getJSON('user_type'),
          type: 'openRes',
          roomId: '',
          source_type: this.getResType === 2 ? 1 : 2, // 1校本 2个人
          school_type: userType.includes('external') ? 2 : 1, // 1校内 2校外
          deviceType: this.currentPlayer.id || '', // 设备ID
          player_name: this.playerName || '', // 播放器名字
          player_key: this.playerKey || '', // 播放器唯一标识符，XR根据这个参数判断打开播放器传什么样的参数
          playerId: this.playerId || '' // 播放器ID
        })
      }
      console.log(cookie.getJSON('user_infor'))
      console.log(data)
      // 一键打开应用程序
      // 检测用户的设备是否是Windows系统
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf('Chrome') > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf('Edg') > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            this.openUriWithInputTimeoutHack(
              process.env.VUE_APP_XR_NAME + '://' + encodeURIComponent(JSON.stringify(data)),
              error => {
                this.visible = true
                // this.$message.error('软件未安装！')
              },
              success => {
                this.visible = false
                this.checkedItem = null
                // console.log('软件已安装！')
              }
            )
          } catch (err) {
            console.log(err)
            this.$message.warning('出错了，请手动打开软件！')
          }
        }
      }
    },
    openSoftware() {
      if (this.getResType === 2) {
        this.$refs.playerModal.visible = true
      } else {
        this.Ok()
      }
    },
    getResourceDetail() {
      const id = this.getId
      if (id) {
        resourceDetail({ id: id }).then(async res => {
          if (res.code != 200) return
          const data = res.data
          this.data = {
            file: {
              id: data.resId,
              cover: data.cover,
              files: data.file,
              softwareImage: data.softwareImage
            },
            name: data.name,
            cover: data.cover,
            isAuth: data.isAuth,
            format: data.format,
            detail: data.detail,
            version: data.version,
            playerId: data.playerId,
            typeName: data.typeName,
            profession: data.profession,
            softwareImage: data.softwareImage,
            subTypeName: data.subTypeName,
            isLike: data.isLike,
            isBookmark: data.isCollect,
            likeNumber: data.likeCount,
            bookmarkNumber: data.collectCount,
            industryName: data.industryName
          }
          if (data.file[0].url !== '') {
            this.params.res_url = data.file[0].url
          }
          if (data.playerDetail && data.playerDetail.files.length > 0) {
            const playerList = []
            const machineMap = {}
            const res = await machineList()
            if (res.code === 200) {
              res.data.list.reduce((pre, cur) => {
                pre[cur.id] = cur.icon
                return pre
              }, machineMap)
            }
            console.log('res', res, machineMap)
            data.playerDetail.files.forEach(item => {
              item.machine.forEach((machine, inx) => {
                playerList.push({
                  id: machine,
                  name: item.machineName[inx] || '未知',
                  icon: machineMap[machine] || require('@/assets/icons/icon_pc@2x.png'),
                  checked: false
                })
              })
            })
            this.playerKey = data.playerDetail.key
            this.playerId = data.playerDetail.id
            this.playerName = data.playerDetail.name
            this.playerList = playerList
            console.log('this.playerList', this.playerList)
          }
          data.file.forEach(item => {
            this.deviceList = [...this.deviceList, ...item.machineName]
          })
          console.log('this.data', this.data)

          this.$forceUpdate()
        })
      }
    },
    getPersonResourceDetail() {
      const id = this.getId
      const reversedNameMap = {
        text: '文本类',
        image: '图片类',
        audio: '音频类',
        video: '视频类',
        model: '3D模型',
        software: '3D实训软件'
      }
      if (id) {
        getPersonResDetails({ id: id }).then(res => {
          console.log('res ----->', res)
          if (res.code != 200) return
          const data = res.data
          this.data = {
            file: {
              id: data.id,
              cover: data.cover,
              files: data.files,
              softwareImage: data.softwareImage
            },
            ...data,
            detail: data.intro,
            typeName: reversedNameMap[data.type],
            subTypeName: this.getSubTypeName(data.type, data.subType),
            isLike: data.isLike,
            isBookmark: data.isBookmark,
            likeNumber: data.likeNumber,
            bookmarkNumber: data.bookmarkNumber,
            isAuth: true
          }
          if (data.files[0].url !== '') {
            this.params.res_url = data.files[0].url
          }
          console.log('this.data ----->', this.data)
          this.setResourceCover()
          this.$forceUpdate()
        })
      }
    },
    getSubTypeName(type, subType) {
      if (type !== 'image' && type !== 'video') {
        return ''
      }
      return `${subType === 1 ? '普通' : '全景'}${type === 'image' ? '图片' : '视频'}`
    },
    async feedback(type) {
      const id = this.getId
      const params = {
        res_id: id,
        type: this.getResType,
        target_url: window.location.href || ''
      }
      switch (type) {
        case 'like':
          await resourceLike(params)
          this.data.isLike = true
          this.$message.success(this.$t('resourceDetails.collect.liked'))
          break
        case 'unlike':
          await resourceUnlike(params)
          this.data.isLike = false
          this.$message.success(this.$t('resourceDetails.collect.cancel'))
          break
        case 'collect':
          await resourceCollect(params)
          this.data.isBookmark = true
          this.$message.success(this.$t('resourceDetails.collect.success'))
          break
        case 'uncollect':
          await resourceUncollect(params)
          this.data.isBookmark = false
          this.$message.success(this.$t('resourceDetails.collect.cancel'))
          break
      }
      this.getDetails()
    },
    getDetails() {
      this.params.resId = this.getId
      this.params.resType = this.getResType === 2 ? 1 : 3
      if (this.getResType === 2) {
        this.getResourceDetail()
      } else {
        this.getPersonResourceDetail()
      }
    },
    setResourceCover(formatKey) {
      const resData = this.data

      if (resData.cover) return
      switch (resData.type) {
        case 'text':
          if (!resData.file || !resData.file.files || !resData.file.files.length || !resData.file.files[0].type) return
          // const regex = /\.([a-zA-Z0-9]+)$/
          const match = resData.file.files[0].type
          const bgMap = {
            ppt: 'ppt',
            pdf: 'pdf',
            doc: 'word',
            docx: 'word',
            xls: 'xlsx',
            xlsx: 'xlsx',
            pptx: 'ppt'
          }
          if (match) {
            resData.cover = require(`@/assets/img/bg_${bgMap[match]}_cover.png`)
          } else {
            resData.cover = require('@/assets/img/bg_text_cover.png')
          }
          break
        case 'audio':
          resData.cover = require('@/assets/img/bg_auido_cover.png')
          break
        case 'model':
          resData.cover = require('@/assets/img/bj_mx@2x.png')
          break
        case 'software':
          resData.cover = require('@/assets/img/bj_sx@2x.png')
          break
      }
    },
    selectPlayer(player) {
      console.log('player', player)
      this.currentPlayer = player
      this.Ok()
    }
  },
  mounted() {
    this.getDetails()
  }
}
</script>

<style lang="less" scoped>
.container {
  // margin-right: 5px;
  padding: 18px 19px;
  overflow-y: scroll;
  display: block !important;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;

    img {
      height: 10px;
      margin-right: 9px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.file {
  display: flex;
  margin-bottom: 10px;
  position: relative;

  img {
    width: 369px;
    height: 208px;
    border-radius: 4px;
    margin-right: 45px;
  }

  .right-content {
    padding: 48px 0 20px;
    .name {
      max-width: 25vw;
    }
    > div {
      margin: 10px 0;

      &:first-child {
        display: flex;
        font-size: 21px;
        font-weight: 550;
        color: #000000;
        line-height: 29px;
        position: relative;
        padding-bottom: 10px;
        align-items: center;

        span {
          width: 61px;
          height: 22.5px;
          font-size: 11px;
          font-weight: 400;
          color: #000000;
          line-height: 15px;
          padding: 4px 20px;
          margin-left: 12px;
          border-radius: 19px;
          background: #f2f2f2;
        }

        &::after {
          bottom: 0;
          left: 0;
          content: '';
          width: 21px;
          height: 3px;
          opacity: 0.6;
          position: absolute;
          border-radius: 2px;
          background: #ef623d;
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
        }
      }

      &:nth-child(2) {
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 21px;
      }
    }

    .button {
      span {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        position: relative;
        margin-right: 48px;
        border-radius: 18px;
        display: inline-block;
        padding: 8px 40px 8px 11px;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);

        img {
          top: -2.5px;
          right: 0;
          width: 36px;
          height: 41px;
          margin-right: 0;
          position: absolute;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .like {
    position: absolute;
    right: 0px;
    top: 55px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5a6b83;
    > div {
      border-radius: 20px;
      background: #f3f5f6;
      margin-left: 15px;
      width: 120px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 20px;
        height: 17px;
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .already {
      color: #ff5500;
    }
  }
}

/deep/ .ant-tabs {
  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    display: none !important;
  }

  .ant-tabs-tab {
    color: #000000;
  }

  .ant-tabs-tab-active.ant-tabs-tab {
    color: #ff6d00;
    font-weight: 550;
    text-align: center;
    position: relative;

    &::after {
      bottom: 0;
      left: 40%;
      content: '';
      width: 21px;
      height: 3px;
      border-radius: 4px;
      position: absolute;
      background: #ff6d00;
    }
  }

  // .ant-tabs-tab
  .info,
  .belong {
    padding: 18px;
    background: #f6f6f6;

    .title {
      display: flex;
      align-items: center;

      img {
        width: 15px;
        margin-right: 10px;
      }

      .label {
        min-width: 65px;
        font-size: 14px;
        color: #59677d;
        font-weight: 550;
        display: inline-block;
        text-align-last: justify;
      }
    }

    .content {
      .label {
        min-width: 77px;
        padding-right: 6px;
        font-size: 14px;
        color: #000000;
        font-weight: 550;
      }

      .label.profession {
        min-width: 65px;
        margin-left: 5px;
        display: inline-block;
        text-align-last: justify;
      }

      span {
        color: #000000;
      }

      > div {
        padding: 10px 20px;

        &:first-child {
          margin-bottom: 5px;

          img {
            width: 21px;
            margin-right: 10px;
          }

          padding-bottom: 0;
        }

        &:last-child {
          display: flex;

          span:last-child {
            line-height: 25px;
            margin-top: -3px;
          }

          // justify-content: space-around;
        }
      }
      .machine {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .info {
    margin-bottom: 10px;

    .title img {
      width: 12px;
    }

    .content > div:first-child {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        width: 25%;
        align-items: center;
        display: flex;
      }
    }
  }
}

.preview-container {
  width: 100%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  padding-right: 5px;
  // &::-webkit-scrollbar{
  //   display: none;
  // }
}
.active {
  color: #ff5500 !important;
}
/deep/ .ant-back-top {
  bottom: 100px;
}
/deep/ .ant-back-top-inner {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  line-height: 36px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  font-size: 17px;
}
/deep/ .ant-back-top {
  right: 60px !important;
}
@media screen and (max-width: 1200px) {
  .file {
    .right-content {
      .name {
        max-width: 18vw;
      }
    }
  }
}
</style>
